import React from "react";
import clsx from "clsx";

import Grid from "@material-ui/core/Grid";

import PrimaryButton from "../../../../components/Buttons/PrimaryButton";
import { SERVICE_CONCEPTS } from "../../../Trades/constants";
import PtfBuilderLogo from "./images/PbLogo.svg";
import BeratungImage from "./images/beratung.png";

import useStyles from "./styles";


const ANLAGEBERATUNG_ITEMS = [
  "Empfehlung von Produkten auf Basis der Geeignetheitsprüfung des Anlegers",
  "Inklusive Abfrage der Anlageziele und -dauer, Kenntnisse und Erfahrungen, der Risikotoleranz sowie der finanziellen Verhältnisse des Kunden, um Risikoeinstufung zu ermitteln",
  "Empfehlungsverbot bei fehlender Eignung",
  <span><b>Optional:</b>&nbsp;Erstellen Sie individuelle und passgenaue Portfolios für Ihre Kunden mit unserem Portfolio Builder</span>
];

const BERATUNGSFREI_OPTIONS = [
  {
    key: SERVICE_CONCEPTS.Anlagevermittlung,
    title: "Anlagevermittlung inkl. Kenntnisse & Erfahrungen",
    items: [
      "Vermittlung von bestimmten Produkten, bei denen der Kunde selbst entscheidet, ob das Produkt zu ihm passt",
      "Prüfung der Angemessenheit mit Abfrage der erforderlichen Kenntnisse und Erfahrungen, damit Kunden Risiken im Zusammenhang mit dem Produkt verstehen und beurteilen können",
      "Wenn Angaben unvollständig oder fehlerhaft, keine Beurteilung der Angemessenheit und somit keine Vermittlung des Produktes möglich",
      "Im Interesse der Kunden müssen Angaben vollständig und korrekt erteilt werden"
    ],
    btnTitle: "Vermittlung starten"
  },
  {
    key: SERVICE_CONCEPTS.ExecutionOnly,
    title: "Reines Ausführungsgeschäft / Execution Only",
    items: [
      "Ausschließlich auf Initiative des Kunden und nur für nicht-komplexe Finanzprodukte zulässig",
      "Keine Prüfung der Geeignetheit oder Angemessenheit für den Kunden",
      "Schneller Verkauf bzw. Kauf auf Wunsch des Kunden"
    ],
    btnTitle: "Ex-Only starten"
  },
];

const ServiceConceptCard = ({ title, items, onSelect, classes, btnTitle }) => (
  <div className={clsx(classes.container, classes.card)}>
    <CardContent title={title} btnTitle={btnTitle} items={items} onSelect={onSelect} classes={classes} />
  </div>
)

const CardContent = ({title, items, onSelect, classes, btnTitle}) => (
  <>
    <div className={classes.header}>{title}</div>
    <div>
      <ul>
        {items.map((item, idx) => (
          <li key={idx}>{item}</li>
        ))}
      </ul>
    </div>
    <div className={classes.btnRow}>
      <PrimaryButton
        text={btnTitle}
        customClasses={{ root: classes.btnRoot }}
        onButtonClick={onSelect}
        iconPosition="right"
      />
    </div>
  </>
)

export default function ServiceConceptSelectionV2({ onServiceConceptChange, footerContent }) {
  const classes = useStyles();

  return (
    <div className="wrapper">
      <h2 className={classes.title}>Investmentberatung</h2>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <div className={classes.card}>
            <div className={classes.advisoryLogosWrapper}>
              <Grid container spacing={3} justify={"center"} alignItems={"center"}>
                <Grid item><img src={BeratungImage} alt="Beratung Logo" className={classes.logo} /></Grid>
                <Grid item><img src={PtfBuilderLogo} alt="Pb Logo" className={classes.logo} /></Grid>
              </Grid>
            </div>
            <div className={clsx(classes.container, classes.blueContainer)}>
              <CardContent
                title="Anlageberatung"
                btnTitle="Beratung starten"
                items={ANLAGEBERATUNG_ITEMS}
                onSelect={() => onServiceConceptChange(SERVICE_CONCEPTS.Anlageberatung)}
                classes={classes}
              />
            </div>
          </div>
        </Grid>
        {BERATUNGSFREI_OPTIONS.map(({ key, title, items, btnTitle }) => (
          <Grid item xs={12} md={6} key={key}>
            <ServiceConceptCard
              title={title}
              btnTitle={btnTitle}
              items={items}
              onSelect={() => onServiceConceptChange(key)}
              classes={classes}
            />
          </Grid>
        ))}
        {footerContent && (
          <Grid item xs={12}>{footerContent}</Grid>
        )}
      </Grid>
    </div>
  );
}
